// Cada action de redux crea su propia instancia de axios (axios.create) o usa
// la instancia global directamente, y el manejo de 401 estaba duplicado e
// inconsistente entre archivos (varios ni siquiera redirigian a /login).
// Este modulo se importa una sola vez, antes que cualquier otro codigo de la
// app, y parchea axios para que CUALQUIER 401, venga de donde venga, mande
// al usuario al login de inmediato.
import axios from "axios";
import { isTokenExpired, clearAuthStorage } from "./authToken";

let loggingOut = false;

function forceLogout() {
  if (loggingOut || window.location.pathname === "/login") return;
  loggingOut = true;
  clearAuthStorage();
  window.location.href = "/login";
}

function attachAuthInterceptor(instance) {
  instance.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error?.response?.status === 401) {
        forceLogout();
      }
      return Promise.reject(error);
    }
  );
  return instance;
}

attachAuthInterceptor(axios);

const originalCreate = axios.create.bind(axios);
axios.create = (config) => attachAuthInterceptor(originalCreate(config));

// Revalida el token aun sin que haya ningun request en curso, para que una
// sesion que caduco mientras la pestana estaba abierta e inactiva tambien
// mande al login sin esperar al siguiente click o request.
setInterval(() => {
  const token = localStorage.getItem("token") || localStorage.getItem("tokenadmin");
  if (token && isTokenExpired(token)) {
    forceLogout();
  }
}, 15000);
